import React, { Component } from 'react';
import './layout.scss';
import { Route } from 'react-router';
import confirmAuth from "../confirmAuth";
import homeCustom from "../homeCustom/homeCustom";

export default class layout extends Component {
  render() {
    return (
      <div className="page-layout">
        <div>
            <Route  path="/"  component={homeCustom} />
            <Route  path="/confirm" component={confirmAuth} />
        </div>
      </div>
    );
  }
}
